export const pathname = "/mynews";

export const page = {
  route(query: QueryParameters<{ entityId?: string }>) {
    return {
      pathname,
      query: { ...query, pageType: "mynews" },
    };
  },
};
